import React, { useMemo } from 'react';
import { Box } from '@mui/material';

import PaypalForm from '../PaypalForm/PaypalForm';
import { ZuoraPaymentPageResponse } from '../../types/ZuoraPayments';
import { ZuoraPaymentMethod } from '@klab-berlin/api-sdk/lib/services/billing';

interface PaymentPaypalContentProps {
  paypalToken: string;
  onResponseHandler: (paymentMethod: ZuoraPaymentMethod, response: ZuoraPaymentPageResponse) => void;
}

const PaymentPaypalContent = ({ paypalToken, onResponseHandler }: PaymentPaypalContentProps) => {

  const memoizedPaypalForm = useMemo(() => {
    return <PaypalForm token={paypalToken} licenceId={1} onResponse={onResponseHandler}/>;
  }, [paypalToken, onResponseHandler]);

  return (
    <Box id='paypal_payment' data-testid='paypal-payment-content'>
      {memoizedPaypalForm}
    </Box>
  );
};

export default PaymentPaypalContent;
